module.exports = __webpack_public_path__ + "img/qgbqs-mf2_32-50.prt.874dcea9.jpg";